// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var Milliseconds = function (x) {
    return x;
};
var tsBridgeMilliseconds = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedNumberType("Milliseconds")("__brandMilliseconds"));
    }
};
var writeMilliseconds = Simple_JSON.writeForeignNumber;
var unwrap = function (v) {
    return v;
};
var showMilliseconds = Data_Show.showNumber;
var readMilliseconds = Simple_JSON.readNumber;
var ordMilliseconds = Data_Ord.ordNumber;
var newtypeMilliseconds = {
    Coercible0: function () {
        return undefined;
    }
};
var makeMilliseconds = Milliseconds;
var eqMilliseconds = Data_Eq.eqNumber;
export {
    Milliseconds,
    makeMilliseconds,
    unwrap,
    newtypeMilliseconds,
    eqMilliseconds,
    ordMilliseconds,
    showMilliseconds,
    readMilliseconds,
    writeMilliseconds,
    tsBridgeMilliseconds
};
//# sourceMappingURL=index.js.map
